import { LMEUserSettings } from "@mcleod/general";
import { AutogenLayoutPartialShipmentPlanning } from "./autogen/AutogenLayoutPartialShipmentPlanning";
import { MultiProfilePlanningTabs } from "./planning/MultiProfilePlanningTabs";
import { PanelProps } from "@mcleod/components";

export class PartialShipmentPlanning extends AutogenLayoutPartialShipmentPlanning {
    private userProfiles: string[] = [];

    override onLoad() {
        if (LMEUserSettings.get()?.manifest_profile != null) {
            this.userProfiles.push(LMEUserSettings.get().manifest_profile);
        }

    new MultiProfilePlanningTabs({
        tabset: this.tabsetManifestPlanningProfiles,
        profileDataSource: this.sourceManifestProfile,
        mainLayoutName: "lme/dispatch/PartialShipmentPlanningSplitView",
        advancedFilterLayout: "lme/dispatch/PartialShipmentPlanningProfileFilter",
        startingProfiles: this.userProfiles,
        profileDescrFieldName: "descr"
        });
    }

    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }

}
